<ng-template #orgName>
  <a [routerLink]="'/' + ROUTES.RESULTS"
     [queryParams]="{organization_id: organization.organization_id}"
     class="event-by__organization-name action-color semi-bold pointer">

    {{ organization.organization_name }}
  </a>
</ng-template>

<div class="event-by d-flex align-items-center"
     (click)="goToResultsByOrganizationId($event)"
     [title]="('view' | t) + ' ' + organization.organization_name + ' ' + ('event_by_events' | t)">

  <app-entity-logo [small]="small" [logo]="organization.logo_image"></app-entity-logo>
  <div *ngIf="small" class="event-by__organization ml-2 text-small">
    <span>Event by</span>

    <ng-template [ngTemplateOutlet]="orgName"></ng-template>
  </div>
  <div *ngIf="!small" class="ml-2 text-small">
    <div class="col-gray-500">Organizer</div>

    <div class="mt-n1">
      <ng-template [ngTemplateOutlet]="orgName"></ng-template>
    </div>
  </div>
</div>
